import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Link, Step, StepButton, StepLabel, Stepper } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';

import RouterLink from '@/components/elements/RouterLink';
import { scrollToElement } from '@/hooks/useScrollToHash';
import { FormItem } from '@/types/gqlTypes';

export interface Props {
  items: FormItem[];
  useUrlHash: boolean;
  scrollOffset?: number;
}
const FormStepper = ({ items, useUrlHash, scrollOffset }: Props) => {
  const { pathname } = useLocation();
  const steps = useMemo(
    () =>
      items
        .filter((i) => !i.hidden)
        .map((i) => ({
          label: i.text,
          anchor: i.linkId,
          testId: `formNavTo-${i.linkId}`,
        })),
    [items]
  );

  const handleClick = useCallback(
    (anchor: string) => {
      const element = document.getElementById(anchor);
      scrollToElement(element, scrollOffset);
    },
    [scrollOffset]
  );

  return (
    <Stepper activeStep={0} orientation='vertical' nonLinear>
      {steps.map((step) => (
        <Step key={step.anchor}>
          <StepLabel
            StepIconComponent={({ className }) => (
              <RadioButtonUncheckedIcon
                color='disabled'
                className={className}
              />
            )}
            sx={{ py: 0 }}
          >
            {useUrlHash ? (
              <RouterLink
                to={`${pathname}#${step.anchor}`}
                replace
                data-testid={step.testId}
              >
                {step.label}
              </RouterLink>
            ) : (
              <StepButton
                data-testid={step.testId}
                onClick={() => handleClick(step.anchor)}
                sx={{
                  '.MuiStepLabel-root': { py: 0 },
                  '.MuiStepLabel-iconContainer': { display: 'none' },
                }}
              >
                {/* style button as link */}
                <Link component='span'>{step.label}</Link>
              </StepButton>
            )}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default FormStepper;
